import React, { useEffect, useState } from "react";
import "./UpdateUserForm.css"; // External CSS file for styling
import { useSelector,useDispatch } from 'react-redux';
import { update_user } from "../features/userSlice";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faPen, faPlus, faMoneyBillTransfer } from "@fortawesome/free-solid-svg-icons";
import { useT } from "../i18n";

const formatJoined = (value) => {
  const date = new Date(String(value || '').replace(' ', 'T'));
  return isNaN(date) ? (value || '-') : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

const UpdateUserForm = () => {

  const { Info } = useSelector((state) => state.users);
  const { t } = useT();
  const [formData, setFormData] = useState({
    name: Info?.name,
    email: Info?.email,
    phone_number:Info?.phone_number,
    phonpe:Info?.phonepay,
    gpay:Info?.googlepay,
    paytm:Info?.paytm,
  });


  useEffect(()=>{
     if(Info?.phone_number){
        setFormData({
            name: Info?.name,
            email: Info?.email,
            phone_number:Info?.phone_number,
            phonpe:Info?.phonepay,
            gpay:Info?.googlepay,
            paytm:Info?.paytm,
          });
     }
  },[Info])

  const [errors, setErrors] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name?.trim()) newErrors.name = "Name is required.";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid.";
    }
    if(formData.phonpe?.trim()){
        if (!/^\d{10}$/.test(formData.phonpe)) {
        newErrors.phonpe = "PhonePe number must be 10 digits.";
      }
    }
    if(formData.paytm?.trim()){
      if(!/^\d{10}$/.test(formData.paytm)) {
        newErrors.paytm = "Paytm number must be 10 digits.";
      }
    }
    if(formData.gpay?.trim()){
      if(!/^\d{10}$/.test(formData.gpay)) {
        newErrors.gpay = "Google Pay number must be 10 digits.";
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
        var form_data_new = new FormData();

        for ( var key in formData ) {
            form_data_new.append(key, formData[key]);
        }
      dispatch(update_user(form_data_new));
    }
  };

  return (
    <div className="pf-screen">
      <div className="pf-head">
        <div className="pf-avatar" aria-hidden="true"><FontAwesomeIcon icon={faUser} /></div>
        <div className="pf-name">
          <h2>{Info?.name || t('My Profile')}</h2>
          <button type="button" className="pf-edit-btn" onClick={() => setIsEditing((v) => !v)} aria-label={t('Edit profile')} aria-expanded={isEditing}>
            <FontAwesomeIcon icon={faPen} />
          </button>
        </div>
      </div>

      <div className="pf-card pf-stats">
        <div><span>{t('Joined since')}</span><strong>{formatJoined(Info?.created_at)}</strong></div>
        <div><span>{t('Phone')}</span><strong>+91{Info?.phone_number}</strong></div>
      </div>

      <div className="pf-card pf-balance">
        <p>{t('Wallet Balance')}: <b>₹{Info?.wallet || 0}</b></p>
        <Link to="/add_fund_auto" className="pf-round" aria-label={t('Add Fund')}><FontAwesomeIcon icon={faPlus} /></Link>
        <Link to="/withdraw" className="pf-round" aria-label={t('Withdraw')}><FontAwesomeIcon icon={faMoneyBillTransfer} /></Link>
      </div>

      {isEditing && <div className="form-container payment-container">
      <h2>{t('Update User Information')}</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">{t("Name")}</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <p className="error">{t(errors.name)}</p>}
        </div>

        <div className="form-group">
          <label htmlFor="email">{t("Email")}</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <p className="error">{t(errors.email)}</p>}
        </div>

        <div className="form-group">
          <label htmlFor="mobile">{t("Mobile Number")}</label>
          <input
            type="text"
            id="phone_number"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
            readOnly={true}
          />
          {errors.mobile && <p className="error">{t(errors.mobile)}</p>}
        </div>

        <div className="form-group">
          <label htmlFor="mobile">{t("PhonePe")}</label>
          <input
            type="text"
            id="phonpe"
            name="phonpe"
            value={formData.phonpe}
            onChange={handleChange}
          />
          {errors.phonpe && <p className="error">{t(errors.phonpe)}</p>}
        </div>
        <div className="form-group">
          <label htmlFor="mobile">{t("Google Pay")}</label>
          <input
            type="text"
            id="gpay"
            name="gpay"
            value={formData.gpay}
            onChange={handleChange}
          />
          {errors.gpay && <p className="error">{t(errors.gpay)}</p>}
        </div>
        <div className="form-group">
          <label htmlFor="mobile">{t("Paytm")}</label>
          <input
            type="text"
            id="paytm"
            name="paytm"
            value={formData.paytm}
            onChange={handleChange}
          />
          {errors.paytm && <p className="error">{t(errors.paytm)}</p>}
        </div>

        <button type="submit" className="submit-btn">
          {t('Update')}
        </button>
      </form>
    </div>}
    </div>
  );
};

export default UpdateUserForm;
